export default __webpack_public_path__ + "static/7-0ddef06cb52cc50b9d0a2a880acde7f1.jpg";